module.exports = __webpack_public_path__ + "static/media/tauchsieder_fragezeichen.859593cb.jpg";